"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveBucket = exports.DERIVED_BUCKETS = void 0;
const task_kind_config_schema_1 = require("./task-kind-config.schema");
exports.DERIVED_BUCKETS = ['urgent', 'week', 'later', 'waiting'];
// Pure function — no clock reads, no side effects. Callers own `now`.
// Past target_time collapses to `urgent` (overdue is normal post-snooze state).
const deriveBucket = (targetTime, now, thresholds) => {
    const deltaSeconds = (targetTime.getTime() - now.getTime()) / 1000;
    if (deltaSeconds <= (0, task_kind_config_schema_1.durationToSeconds)(thresholds.urgent))
        return 'urgent';
    if (deltaSeconds <= (0, task_kind_config_schema_1.durationToSeconds)(thresholds.week))
        return 'week';
    if (deltaSeconds <= (0, task_kind_config_schema_1.durationToSeconds)(thresholds.later))
        return 'later';
    return 'waiting';
};
exports.deriveBucket = deriveBucket;
//# sourceMappingURL=priority.js.map